import { RegisterAsIndividualIcon } from "@/assets";
import NewUsersIcon24 from "@/assets/SVG/newUsersIcon24";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, Typography } from "@mui/material";

function AreaReport({ activeTripsStats }) {
  return (
    <>
      <Grid display={"flex"} flexDirection={"column"} gap={"20px"}>
        {activeTripsStats.map((tripStat, index) => (
          <Grid
            key={index}
            display={"flex"}
            flexDirection={"column"}
            gap={"20px"}
          >
            {`${tripStat.name} - ${tripStat.city}`}
            <Grid display={"flex"} flexDirection={"column"} gap={"10px"}>
              <Typography
                variant="body2"
                color={"var(--emr-primary-color-text)"}
              >
                آمار کلی
              </Typography>
              <Grid
                display={"flex"}
                flexDirection={"row"}
                gap={"10px"}
                flexWrap={"wrap"}
                rowGap={"20px"}
              >
                <Card
                  title={"کل مراجعین"}
                  icon={<RegisterAsIndividualIcon />}
                  counter={tripStat.totalPatients}
                  unit={"نفر"}
                />
                <Card
                  title={"کل جهادگران"}
                  icon={<RegisterAsIndividualIcon />}
                  counter={tripStat.maleMembers + tripStat.femaleMembers}
                  unit={"نفر"}
                />
                <Card
                  title={"کل جهادگران مرد"}
                  icon={<RegisterAsIndividualIcon />}
                  counter={tripStat.maleMembers}
                  unit={"نفر"}
                />
                <Card
                  title={"کل جهادگران زن"}
                  icon={<RegisterAsIndividualIcon />}
                  counter={tripStat.femaleMembers}
                  unit={"نفر"}
                />
              </Grid>
            </Grid>
            {tripStat.moduleStats &&
              tripStat.moduleStats.map((moduleStat, index) => (
                <Grid display={"flex"} flexDirection={"column"} gap={"10px"}>
                  <Typography
                    variant="body2"
                    color={"var(--emr-primary-color-text)"}
                  >
                    {moduleStat.name}
                  </Typography>
                  <Grid
                    key={index}
                    display={"flex"}
                    flexDirection={"row"}
                    gap={"10px"}
                    flexWrap={"wrap"}
                    rowGap={"20px"}
                  >
                    <Card
                      title={"مراجعین"}
                      icon={<RegisterAsIndividualIcon />}
                      counter={moduleStat.patients}
                      unit={"نفر"}
                    />
                    <Card
                      title={"مراجعین در انتظار"}
                      icon={<NewUsersIcon24 />}
                      counter={moduleStat.waitingPatients}
                      unit={`نفر - ${((moduleStat.waitingPatients * 100) / moduleStat.patients).toFixed(1)}%`}
                    />
                    <Card
                      title={"مراجعین پذیرش شده"}
                      icon={<NewUsersIcon24 />}
                      counter={moduleStat.receptedPatients}
                      unit={`نفر - ${((moduleStat.receptedPatients * 100) / moduleStat.patients).toFixed(1)}%`}
                    />
                  </Grid>
                </Grid>
              ))}
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default AreaReport;
